import api from "@/api/v24/api";

const apiKommune = {
  getKommuner: () => {
    return api.execute("HentKommuner", null, "Kommuner");
  }
};

export default apiKommune;
